export default __webpack_public_path__ + "static/media/copper.cfb65ef2.png";